import React from 'react';
import './ios.modal.style.sass';
import {Modal} from "rsuite";
import iaps from '../../assets/image/icons/iaps.png';

const IosModal = ({iosModal, ToggleModalIos}) => {
    return (
        <Modal size='xs' show={iosModal} onHide={ToggleModalIos} className='ios-modal'>
            <Modal.Header className='ios-modal-header'>
                <Modal.Title>توجه</Modal.Title>
            </Modal.Header>
            <Modal.Body className='ios-modal-body'>
                <p>با توجه به محدودیت های اخیر اپل در مورد نرم افزار های ایرانی هم اکنون
                    امکان نصب برنامه برای اپل فقط از طریق لینک های زیر امکان پذیر است.</p>
                <p><span>توجه :</span> پرداخت هرگونه هزینه داخل اپ استور ها هیچ گونه مسئولیتی برای
                    زیتونیکس ایجاد نمیکند و زیتونیکس بابت نصب اپلیکشن خود هزینه ای از مشتری
                    دریافت نمیکند.</p>
                <p><span>لطفا قبل از پرداخت هرگونه هزینه</span> در مورد صحت عملکرد برنامه و لایسنس از پشتیبانی مربوط به خوده اپ استور
                    تحقیق کنید . زیتونیکس هیچگونه مسئولیتی در قبال ران شدن نرم افزار و لایسنس قبول نمیکند.سورس اصلی نرم
                    افزار کاملا تست شده و سالم است</p>
                <p>لازم به ذکر است امکانات دستگاه طبق روال قبل از طریق پیامک،سایت و ربات تلگرام نیز قابل استفاده است</p>
                <div className='ios-modal-action'>
                    <br />
                    <a href="https://app.iapps.ir/i/43011691" target="_blank" rel="noopener noreferrer"><img src={iaps} alt='Iaps ios application xitonix download' /></a>
                    <br />
                    <p>کد تخفیف  :xitonix20</p>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default IosModal;